import React, { useCallback, useMemo, useState } from 'react';
import './style.scss';
import { Description, SubTitle } from '../../components/layouts';
import Sequence from '../../components/sequence';
import Visibility from '../../components/Visibility';
import { getSeqFrames, getTrack, pureTrans } from '../../helpers';
import { AppContext } from '../../Context';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';

const FRAME_LENGTH = 61;

function getIndex(progress) {
  return pureTrans(progress, [0, 0.75], [0, FRAME_LENGTH - 1], 0);
}

function getOpacity(progress) {
  return pureTrans(progress, [-0.3, 0.3, 0.7], [0, 0.3, 1], 3);
}

function getMaskOpacity(progress) {
  return pureTrans(progress, [0, 0.5, 0.6], [0, 0, 0.2], 3);
}

function getTextY(progress) {
  return pureTrans(progress, [0, 0.5, 0.8], [10, 0, -10], 3);
}

const track = getTrack({ block: 4 });

export function ColorDesktop() {
  const [framesLoaded, setFramesLoaded] = React.useState(false);
  const [frozen, freeze] = useState(true);
  const [progress, setProgress] = useState(0);
  const [index, opacity, maskOpacity, textY] = useMemo(() => {
    return [getIndex(progress), getOpacity(progress), getMaskOpacity(progress), getTextY(progress)];
  }, [progress]);

  const handleUpdate = useCallback(
    (e, { calculations }) => {
      const { percentagePassed, pixelsPassed, height, offScreen } = calculations;
      freeze(offScreen || pixelsPassed <= -1000 || pixelsPassed >= height + 1000);
      setProgress(percentagePassed);
    },
    [setProgress, freeze]
  );

  const { webpSupport, webpDetectionFinished } = React.useContext(AppContext);

  const frames = useMemo(() => {
    return getSeqFrames({
      prefix: 'color',
      mobile: false,
      webpSupport: false,
      ext: 'jpg',
      len: FRAME_LENGTH
    });
  }, [webpSupport]);

  const onFramesLoaded = useCallback(() => {
    setFramesLoaded(true);
  }, [setFramesLoaded]);

  const seqReady = !frozen && webpDetectionFinished;
  return (
    <Visibility
      fireOnMount
      offset={[-1000, 1000]}
      onUpdate={handleUpdate}
      className="page-section inverted section-color"
      id="position-color"
      data-track={track}
    >
      <div className="sticky-content">
        <div className="section-content">
          <div style={{ opacity, transform: `translate(-50%, ${textY}%)` }}>
            <SubTitle>创新工艺，个个出彩</SubTitle>
            <Description>
              采用缎面 AG 工艺<sup>2</sup>，质感中透露出微微光泽，注入生机与活力。
            </Description>
          </div>
        </div>
        <div className="section-background">
          <div className="sequence-wrapper">
            <Sequence name="color-d" current={index} onload={onFramesLoaded} frames={frames} active={seqReady} />
            <div className="dark-mask" style={{ backgroundColor: `rgba(0,0,0,${maskOpacity})` }} />
            <SeqencePlaceholder src={frames[frames.length - 1]} visible={!seqReady || !framesLoaded} />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
